import * as React from 'react';
import type { ValidationPropType } from './use-validation';
import { useValidation } from './use-validation';

export type CheckboxFieldPropType = ValidationPropType;

export function useCheckboxField(
  inputRef: React.RefObject<HTMLInputElement | null>,
  externalChecked: boolean = false,
  { error, validate }: ValidationPropType = {},
) {
  const [invalid, validationMessage, updateValidation, triggerInvalid] = useValidation(inputRef, error, validate);

  const [internalChecked, setInternalChecked] = React.useState(externalChecked);

  React.useEffect(() => {
    setInternalChecked(externalChecked);
  }, [externalChecked]);

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setInternalChecked(e.currentTarget.checked);
      updateValidation(e.currentTarget);
    },
    [updateValidation],
  );

  const onInvalid = React.useCallback(
    (e: React.InvalidEvent<HTMLInputElement>) => {
      e.preventDefault();
      triggerInvalid(e.currentTarget);
    },
    [triggerInvalid],
  );

  return React.useMemo(
    () => ({ invalid, validationMessage, inputProps: { checked: internalChecked, onChange, onInvalid } } as const),
    [internalChecked, invalid, onChange, onInvalid, validationMessage],
  );
}
